import React from "react";

// set the defaults
const PageTitleContext = React.createContext({
  title: "",
  setTitle: (() => {} )as any
});

export default PageTitleContext;
